<template>
  <GeneralContent />  <!--En analisis no lo veo en neumaticos -->
</template>

<script setup>
  import { onMounted } from "vue";
  import { useStore } from 'vuex'
  import GeneralContent from "~/components/GeneralContent.vue";

  import { NEGOCIOS } from "~/constants/negocios";

  const store = useStore();
  const modo_sistema = useState('modo_sistema');
  
  const { 
    clearCart,
  } = useCartBridge();
  
  const cookieHistory = useCookie('routeHistory');
  const cokkieMedidasFlujoAuto = useCookie('MedidasFlujoAuto');

  const route = useRoute();
  const router = useRouter();

  const { getDeviceUUID } = useGeneradorUUIDS();
  const { obtenerVistaId, RegistrarFunnel, registrarVistaVisitada } = useFunnel();

  // Métodos
  const removeTrackingParameters = () => {
    // Lista de parámetros de seguimiento a eliminar
    const trackingParams = ['_gl', '_ga', '_gcl_au', '_ga_5V657JNG3L'];

    let newUrl = route.fullPath;
    let modified = false;

    trackingParams.forEach(param => {
      if (route.query[param]) {
        newUrl = newUrl.replace(new RegExp(`[?&]${param}=[^&]*(&|$)`), match =>
          match.endsWith('&') ? '&' : ''
        );
        modified = true;
      }
    });

    // Si la URL termina con "?" o tiene "?&", limpiamos eso también
    newUrl = newUrl.replace(/\?&/, '?').replace(/\?$/, '');

    if (modified) {
      router.replace(newUrl);
    }
  };

  async function registro_funnel() {
    let id_de_vista = null;
    //funnel para raiz
    //console.log("modo_sistema.value -> : ", modo_sistema.value);

    if(modo_sistema.value===NEGOCIOS.HOME){
      const uuid_dispositivo = await getDeviceUUID();
      await RegistrarFunnel(uuid_dispositivo, "no", null);
      id_de_vista = await obtenerVistaId(`/`, 1);
      if(id_de_vista==null){ return; }
      await registrarVistaVisitada(id_de_vista);
    }
  }

  function limpiar_sistema() {
    // Primera inicialización
    ////console.log("removiendo, filtros_seleccionados, orderFilter, payment, giftcard del localstorage...");
    localStorage.removeItem("filtros_seleccionados");
    localStorage.removeItem("orderFilter");
    localStorage.removeItem("payment");
    localStorage.removeItem("giftcard");
    cookieHistory.value = null;

    //dc: tengo dudas con este segmento
    if (cokkieMedidasFlujoAuto.value && cokkieMedidasFlujoAuto.value.length > 0 && (cokkieMedidasFlujoAuto.value[0].front || cokkieMedidasFlujoAuto.value[0].rear)) {
      clearCart();
    }

    const loadingBar = document.getElementById("loading-bar");
    if (loadingBar) {
      loadingBar.style.width = "0%";
    }
  }

  // Lifecycle hooks
  onMounted(() => {
    removeTrackingParameters();
    registro_funnel();
    limpiar_sistema();
  });
</script>
